import styled from '@emotion/native'

interface CircleSelected {
  isSelected?: boolean
  activeColor?: string
}

export const Container = styled.TouchableOpacity(({ theme }) => ({
  width: '100%',
  paddingVertical: theme.sizes.sm,
  justifyContent: 'space-between',
  flexDirection: 'row',
}))

export const Circle = styled.View<CircleSelected>(({ theme, isSelected, activeColor }) => ({
  width: theme.sizes.sm,
  height: theme.sizes.sm,
  borderWidth: 2,
  borderRadius: theme.sizes.sm,
  borderColor: isSelected ? (activeColor ?? theme.colors.primary) : theme.colors.background3,
}))

export const InnerCircle = styled.View<CircleSelected>(({ theme, isSelected, activeColor }) => ({
  flex: 1,
  backgroundColor: isSelected ? (activeColor ?? theme.colors.primary) : 'transparent',
  borderWidth: 1,
  borderRadius: 50,
  borderColor: 'white',
}))
